import { Radio, Space } from 'antd';
import React from 'react';
import './RadioInputStyle.css';

const RadioGroupListInput = props => {
    const { def, data, onChange, state } = props;

    return <Radio.Group
        value={data}
        onChange={(e) => { if (!state.readonly) onChange(def.dataKey, e.target.value) }}
        data-input={'radiogrouplistinput_de'}
        className={'radioinput_de'}
    >
        <Space direction='vertical'>
            {def.values.map((val, idx) => {
                const label = def.options[idx];

                return <Radio
                    value={val}
                    disabled={state.readonly}
                    style={{ color: 'black !important' }}
                    onClick={() => { if (data === val && !state.readonly) onChange(def.dataKey, null) }}
                >
                    {label}
                </Radio>
            })}
        </Space>
    </Radio.Group>
}

export default RadioGroupListInput;
